// Sıra önemli: önce `process` (masaüstü servisleri okuyor), sonra köprü, sonra arayüz.
import './polyfills';
import './installBridge';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '../../renderer/src/App';
import { LanguageProvider } from '../../renderer/src/lib/i18n';
import { ThemeProvider } from '../../renderer/src/lib/theme';
import { PreferencesProvider } from '../../renderer/src/features/preferences/usePreferences';
import '../../renderer/src/index.css';

/**
 * TalkNote web uygulaması girişi. Arayüz masaüstüyle aynı (renderer/App);
 * yalnızca `window.zabit` köprüsü tarayıcı sürümü (bridge.ts).
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <ThemeProvider>
        <PreferencesProvider>
          <App />
        </PreferencesProvider>
      </ThemeProvider>
    </LanguageProvider>
  </StrictMode>
);
